export default "__VITE_ASSET__CRcuNOH9__"